import { jsx as t } from "react/jsx-runtime";
import "react";
import { p as s } from "../../index-B0ARwqly.mjs";
import { classes as o } from "../../utils/helpers.js";
function u({
  list: p = [],
  type: l = "unordered",
  // 'unordered' | 'ordered'
  classname: r = ""
}) {
  return /* @__PURE__ */ t("ul", { className: o(["generic-list", `${r}`]), children: p.map((e, i) => /* @__PURE__ */ t(
    "li",
    {
      className: o(["generic-list__item", `${r}__item`]),
      children: typeof e == "string" && e !== "" ? s(e) : e
    },
    r === "" ? `generic-list-${i}` : `${r}-${i}`
  )) });
}
export {
  u as GenericList,
  u as default
};
